<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconHome_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M1.751 4.51A2 2 0 0 0 1 6.07v7.834c0 .424.164.831.456 1.13.291.3.687.47 1.1.47h2.92v-7.06c0-.395.283-.714.632-.714h3.785c.348 0 .63.32.63.713v7.06h2.921c.413 0 .809-.168 1.1-.468.292-.3.456-.707.456-1.13V6.07a2 2 0 0 0-.751-1.562l-5-3.998a2 2 0 0 0-2.498 0l-5 3.998Z"
        clip-rule="evenodd"
    />
</svg>
